(function() {
  var isSyncingGift = false;
  var syncTimer = null;

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function(response) {
        return response.json();
      })
      .then(function(sections) {
        var parser = new DOMParser();

        if (sections['cart-drawer']) {
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          var currentDrawer = document.querySelector('cart-drawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }

        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
          var currentBubble = document.querySelector('#cart-icon-bubble');

          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }
      });
  }

  function syncFreeGift() {
    if (isSyncingGift) return Promise.resolve();

    var giftVariantId = Number(window.MK_FREE_GIFT_VARIANT_ID);
    var threshold = Number(window.MK_FREE_GIFT_THRESHOLD);

    if (!giftVariantId || !threshold) return Promise.resolve();

    isSyncingGift = true;

    return fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var giftItem = cart.items.find(function(item) {
          return item.variant_id === giftVariantId;
        });

        var totalWithoutGift = cart.items.reduce(function(total, item) {
          if (item.variant_id === giftVariantId) return total;
          return total + item.final_line_price;
        }, 0);

        if (totalWithoutGift >= threshold && !giftItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: giftVariantId,
              quantity: 1,
              properties: {
                _free_gift: 'true'
              }
            })
          });
        }

        if (totalWithoutGift < threshold && giftItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: giftItem.key,
              quantity: 0
            })
          })
          .then(function() {
            return fetch('/cart.js');
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(updatedCart) {
            if (updatedCart.item_count === 0) {
              window.location.reload();
              return;
            }

            return refreshCartDrawer();
          });
        }
      })
      .then(function() {
        isSyncingGift = false;
      })
      .catch(function(error) {
        console.error(error);
        isSyncingGift = false;
      });
  }

  function scheduleGiftSync() {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(function() {
      syncFreeGift().then(function() {
        return refreshCartDrawer();
      });
    }, 500);
  }

  var originalFetch = window.fetch;

  window.fetch = function() {
    var url = arguments[0];
    var urlString = typeof url === 'string' ? url : url.url;

    return originalFetch.apply(this, arguments).then(function(response) {
      if (
        urlString &&
        (
          urlString.includes('/cart/add') ||
          urlString.includes('/cart/change') ||
          urlString.includes('/cart/update') ||
          urlString.includes('/cart/clear')
        )
      ) {
        response.clone().text().then(function() {
          scheduleGiftSync();
        });
      }

      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', function() {
    scheduleGiftSync();
  });

  document.addEventListener('click', function(event) {
    var arrow = event.target.closest('.mk-cart-upsell__arrow');

    if (arrow) {
      event.preventDefault();

      var upsell = arrow.closest('.mk-cart-upsell');
      var items = upsell.querySelectorAll('.mk-cart-upsell__item');
      if (!items.length) return;

      var currentIndex = Number(upsell.dataset.index || 0);
      var goingNext = arrow.classList.contains('mk-cart-upsell__next');

      var nextIndex = goingNext
        ? (currentIndex + 1) % items.length
        : (currentIndex - 1 + items.length) % items.length;

      upsell.dataset.index = nextIndex;

      items.forEach(function(item) {
        item.classList.remove('is-active', 'is-prev', 'is-next');
      });

      var currentItem = items[currentIndex];
      var nextItem = items[nextIndex];

      nextItem.classList.add(goingNext ? 'is-next' : 'is-prev');

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          currentItem.classList.add(goingNext ? 'is-prev' : 'is-next');
          nextItem.classList.add('is-active');
          nextItem.classList.remove(goingNext ? 'is-next' : 'is-prev');
        });
      });

      return;
    }

    var addButton = event.target.closest('[data-upsell-variant-id]');
    if (!addButton) return;

    event.preventDefault();

    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: addButton.dataset.upsellVariantId,
        quantity: 1
      })
    }).catch(function(error) {
      console.error(error);
      addButton.disabled = false;
      addButton.textContent = 'Add';
    });
  });
})();